// features/configuration.validation.js

export const configurationValidation = {
  sendgrid_credential_fid: (value) => {
    if (!value) return "A linked credential is required.";
    return "";
  },

  from_email: (value) => {
    if (!value?.trim()) return "From email is required.";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())) return "From email is not valid.";
    return "";
  },

  reply_to_email: (value) => {
    if (!value?.trim()) return "";
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim())) return "Reply-to email is not valid.";
    return "";
  },
};
